import { ITextProps, Text } from 'native-base';
import React, { ReactNode } from 'react';

export type TextLabelProps = ITextProps & {
  children?: ReactNode;
  isMuted?: boolean;
};

export default function TextLabel({ children, isMuted = false, ...props }: TextLabelProps) {
  return (
    <Text
      color={isMuted ? 'muted.400' : 'white'}
      fontSize="xs"
      lineHeight="xs"
      testID="TextLabel"
      textAlign="center"
      {...props}
    >
      {children}
    </Text>
  );
}
